import React, { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';

const WORKING_MESSAGES = [
  "Setting things up...",
  "Getting this ready...",
  "Tightening the screws...",
  "Sprinkling some magic...",
  "Warming up the engines...",
  "Brewing some code...",
  "Connecting the dots...",
  "Polishing the edges...",
  "Assembling the pieces...",
  "Almost there...",
  "Working some magic...",
  "Thinking hard...",
  "Cooking something good...",
  "Fine-tuning the details...",
  "Building something awesome...",
  "Putting it all together...",
  "Making it shine...",
  "Running the numbers...",
  "Crafting your response...",
  "Loading creativity...",
];

const TypingIndicator = () => {
  const [msgIndex, setMsgIndex] = useState(() => Math.floor(Math.random() * WORKING_MESSAGES.length));

  useEffect(() => {
    const interval = setInterval(() => {
      setMsgIndex(prev => (prev + 1) % WORKING_MESSAGES.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex gap-3" data-testid="typing-indicator">
      <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-blue-600 to-cyan-500 flex items-center justify-center text-[10px] font-bold text-white shrink-0 mt-0.5">E1</div>
      <div>
        <div className="flex items-center gap-2 mb-2">
          <span className="text-sm font-semibold text-foreground">E1</span>
        </div>
        <div className="flex items-center gap-2.5 px-4 py-3 bg-muted rounded-xl border border-border">
          <Loader2 className="w-4 h-4 text-primary animate-spin shrink-0" />
          <span className="text-sm text-muted-foreground transition-all duration-300" key={msgIndex}>
            {WORKING_MESSAGES[msgIndex]}
          </span>
        </div>
      </div>
    </div>
  );
};

export { WORKING_MESSAGES };
export default TypingIndicator;
